export default "__VITE_ASSET__GjfqdziC__"